module.exports = __webpack_public_path__ + "fonts/nexa-heavy.a535e35c.ttf";